import { Component } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import ModalLayer from '@components/ModalLayer'
import CloseButton from '@components/CloseButton'
import { getReadableTextColor } from '@helpers/color_scheme_helpers.js'
import { ThemeContext } from '../../../base/ThemeContext'

export default class ModalCard extends Component {
  constructor(props) {
    super(props)
    this.closeButtonRef = null
  }

  closeButtonRefCallback = c => {
    this.closeButtonRef = c
  }

  handleTapClose = event => {
    this.props.onTapClose(event, this.props.onTapCloseArgs)
  }

  getCloseButtonContent(x, y, zIndex, opacity) {
    const colorScheme = this.context
    return (
      <CloseButton
        x={x}
        y={y}
        onTap={this.handleTapClose}
        opacity={opacity}
        zIndex={zIndex}
        colorScheme={colorScheme}
      />
    )
  }

  render() {
    const { width, height, cardX, cardY, cardWidth, cardHeight, zIndex } = this.props
    const transformString = `translate(${cardX}px, ${cardY}px)`
    const cardStyle = {
      left: 0,
      top: 0,
      WebkitTransform: transformString,
      MozTransform: transformString,
      msTransform: transformString,
      transform: transformString,
      width: cardWidth,
      height: cardHeight,
      zIndex: zIndex,
    }
    const colorScheme = this.context
    const backgroundColor = colorScheme.secondary
    const cardContentStyle = {
      height: cardHeight, // so setting overflow-y allows scrolling
      backgroundColor,
      color: getReadableTextColor(backgroundColor, colorScheme),
    }
    const contentHolderStyle = {
      width: cardWidth,
      height: cardHeight,
    }
    const closeButton = this.getCloseButtonContent(cardX + cardWidth, cardY, zIndex + 1, 1)
    return (
      <div>
        <ModalLayer width={width} height={height} onTap={this.handleTapClose} zIndex={zIndex} />

        <div className="timeline-modal-card z-depth-2" style={cardStyle}>
          <div className="card-content-holder" style={contentHolderStyle}>
            <div className="card-content" style={cardContentStyle}>
              {this.props.children}
            </div>
          </div>
        </div>
        {closeButton}
      </div>
    )
  }
}
ModalCard.contextType = ThemeContext
ModalCard.propTypes = {
  zIndex: PropTypes.number,
}
ModalCard.defaultProps = {
  width: '100%',
  height: '100%',
  cardX: 20,
  cardY: 20,
  cardWidth: 100,
  cardHeight: 100,
  cardBackgroundColor: '#FFFFFF',
  zIndex: 51,
  onTapClose: noop,
  onTapCloseArgs: null,
}
